import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
// import '../node_modules/dist/css/bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import App from "./App";

ReactDOM.render(
  <BrowserRouter>
    <App />
    <ToastContainer />
  </BrowserRouter>,
  document.getElementById("root")
);
